//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost, axiosGet } from '../../axios/axios'
import { createFieldConfig } from '../../components/QSelectUtils'

import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import FilesGroup from '../../components/File/FilesGroup.js'
import FilesField from '../../components/File/FilesField.vue'
import ReadonlyDocumentsField from '../../components/File/ReadonlyDocumentsField.vue'

export default {
  components: {
    FilesField,
    ReadonlyDocumentsField,
    ItemsSearchField
  },
  props: {
    inputOperation: {
      type: Object,
      default: null
    },
    action: {
      type: Object,
      default: null
    },
    record: {
      type: Object,
      default: null
    },
    recordId: {
      type: Number,
      default: null
    },
    defaultComment: {
      type: String,
      default: null
    },
    fastFix: {
      type: Boolean,
      default: false
    },
    noteIds: {
      type: Array,
      default: null
    },
    sourceProps: {
      type: Object,
      default: function () {
        return null
      }
    }
  },
  data: function () {
    return {
      operation: {
        fileIds: [],
        user: null,
        time: null,
        comment: null,
        recordSource: null,
        requestReportId: null,
        skipReason: null
      },
      filesGroup: new FilesGroup({
        categoryKey: 'serviceObjectMaintenanceNotes',
        sourceConfig: {
          objectId: this.recordId,
          removeURL: '/service/delta/document/deleteFromObject'
        }
      }),
      loading: false,
      negativeMessage: null,

      selectedFastFixMode: null,
      reasonsFieldConfig: createFieldConfig({ allRecordsFn: this.getReasons })
    }
  },
  computed: {
    readonly: function () {
      return this.action && this.action.key === 'delete'
    }
  },
  watch: {
    selectedFastFixMode: function (value) {
      this.filesGroup.clear()
      this.operation.comment = null
      this.operation.skipReason = null
      this.$set(this.record, 'selectedFastFixMode', value)
      this.$set(this.record, 'validate', true)
      this.onValidate()
    }
  },
  created: function () {
    if (this.action.additionalConditions && this.action.additionalConditions.length) {
      this.action.additionalConditions.forEach(additionalCondition => {
        if (!additionalCondition.checkCondition(this.record)) {
          this.onClose()
          this.negativeMessage = additionalCondition.negativeMessage
          this.$q.notify({
            type: 'negative',
            message: this.negativeMessage,
            progress: true,
            timeout: 15000
          })
          return additionalCondition.negativeMessage
        }
      })
    }

    if (this.inputOperation) {
      this.operation.comment = this.inputOperation.comment
      this.operation.fileIds = this.inputOperation.fileIds

      this.operation.user = this.inputOperation.user
      this.operation.time = this.inputOperation.time
      this.operation.commentType = this.inputOperation.commentType
      this.operation.recordSource = this.inputOperation.recordSource ? this.inputOperation.recordSource.key : null
      this.operation.requestReportId = this.inputOperation.requestReportId

      this.filesGroup.clear()
      if (this.operation.fileIds) {
        this.filesGroup.pushFiles(this.operation.fileIds.map(fileId => {
          return { id: fileId, name: 'Замечание к объекту' + '-' + fileId }
        }))
      }
    } else {
      this.operation.fileIds = []
      this.operation.comment = this.defaultComment
      this.operation.commentType = null

      if (this.sourceProps) {
        this.operation.recordSource = this.sourceProps.recordSource
        if (this.sourceProps.requestReportId) {
          this.operation.requestReportId = this.sourceProps.requestReportId
        }
      } else {
        this.operation.recordSource = 'serviceObject'
      }

      this.operation.user = this.$store.getters.getUser.name
      this.operation.time = null
    }
  },
  methods: {
    onValidate: function () {
      let validate = true

      const reason = this.$refs.reason
      if (reason) {
        validate = reason.validate() && validate
      }

      const reasonDescription = this.$refs.reasonDescription
      if (reasonDescription) {
        validate = reasonDescription.validate() && validate
      }

      const files = this.$refs.files
      if (files) {
        validate = files.validate() && validate
      }

      return validate
    },
    onClose: function () {
      this.$emit('cancel')
    },
    uploadFiles: async function () {
      try {
        return await this.filesGroup.uploadFiles({
          notify: true,
          target: this
        })
      } catch (error) {
        throw new Error(error.message)
      }
    },
    onSave: async function (skip = false) {
      if (this.noteIds && this.noteIds.length) {
        return this.onMultipleCancel()
      }

      this.loading = true

      const result = await this.uploadFiles(this.filesGroup)
      let successFileIds = []
      if (result) {
        const filesLoad = result.results.filter(item => item.status !== 'rejected') || []
        successFileIds = filesLoad.map(item => {
          return item.value.data.id
        })
        this.$set(this.operation, 'fileIds', [...(this.operation.fileIds || []), ...successFileIds])
      }

      const formData = new FormData()
      if (this.recordId) {
        formData.set('id', this.recordId)
      }

      const operationToServer = JSON.parse(JSON.stringify(this.operation))

      if (this.fastFix) {
        if (skip) {
          formData.set('operation', 'pass')
        } else {
          formData.set('operation', this.selectedFastFixMode)
          operationToServer.skipReason = operationToServer.skipReason && operationToServer.skipReason.id
          if (this.selectedFastFixMode === 'fix') {
            operationToServer.isPhotoRequired = true
          }
        }
      } else {
        if (this.action) {
          formData.set('operation', this.action.key)
        }
      }

      formData.set('properties', JSON.stringify(operationToServer))

      return axiosPost({
        url: '/service/delta/journal/serviceobjectmaintenancenotes/editOperation',
        data: formData,
        onSuccess: (response) => {
          let msg = ''
          if (!this.inputOperation) {
            msg = 'Операция добавлена'
          } else {
            msg = 'Изменения сохранены'
          }
          this.$q.notify({
            type: 'positive',
            message: msg,
            progress: true,
            timeout: 3000
          })

          this.$emit('update')
          this.onClose()

          return response && response.data
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response && response.message || 'Ошибка изменения операции',
            progress: true,
            timeout: 5000
          })

          return Promise.reject(response && response.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onMultipleCancel: function () {
      this.loading = true

      const formData = new FormData()
      formData.set('ids', this.noteIds.join(','))
      formData.set('comment', this.operation.comment || '')

      return axiosPost({
        url: '/service/delta/journal/serviceobjectmaintenancenotes/multipleCancel',
        data: formData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: response && response.data && response.data.result || '',
            progress: true,
            timeout: 5000
          })

          this.$emit('update')
          this.onClose()

          return response && response.data
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response && response.message || 'Ошибка аннулирования замечаний',
            progress: true,
            timeout: 5000
          })

          return Promise.reject(response && response.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onRemoveFile: function ({ file: fileWrapper, filesGroup }) {
      filesGroup.removeFile(fileWrapper)
      const commentFileIds = this.operation.fileIds.filter(id => id !== fileWrapper.document.id)
      this.$set(this.operation, 'fileIds', commentFileIds)
    },
    getReasons: function () {
      return axiosGet({
        url: '/service/delta/journal/serviceobjectmaintenancenotes/getMaintenanceNoteSkipReasons',
        onSuccess: (response) => {
          return response.data && response.data.result
        },
        onFailure: 'Ошибка загрузки причин'
      })
    }
  }
}

